import { Category } from '@hub/shared'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import './profile-categories.component.scoped.scss'

interface Props {
  categories: Category[]
  openCategories: boolean
  onSetOpenCategories: (open: boolean) => void
}

export default ({ categories, openCategories, onSetOpenCategories }: Props) => {
  const { t, i18n } = useTranslation('cardSocialNetwork')

  const getCategoryByLanguage = useCallback(
    (category: Category) => {
      if (i18n.language?.startsWith('pt')) {
        return category.description
      }
      if (i18n.language?.startsWith('es')) {
        return category.description_es
      }
      return category.description_en
    },
    [i18n.language]
  )

  const handleSetOpenCategories = useCallback(
    (open: boolean) => {
      if (onSetOpenCategories && typeof onSetOpenCategories === 'function') {
        onSetOpenCategories(open)
      }
    },
    [onSetOpenCategories]
  )

  return (
    <div>
      {categories?.map((category, i) => {
        return (
          <span className={`category ${openCategories ? 'open' : ''}`} key={category.id} title={getCategoryByLanguage(category)}>
            {getCategoryByLanguage(category)}
            {(!openCategories && i + 1 !== categories?.length) || (openCategories && category?.children?.length) ? (
              <span className="mx-1">-</span>
            ) : null}
            {openCategories && category?.children?.length
              ? category?.children?.map((c, j) => {
                  return (
                    <span className="sub-categories" title={getCategoryByLanguage(c)} key={c?.id}>
                      {j !== 0 ? <span className="mx-1">-</span> : null}
                      {getCategoryByLanguage(c)}
                      {j + 1 === category?.children?.length ? <span>;</span> : null}
                    </span>
                  )
                })
              : null}
          </span>
        )
      })}
      <i
        className={`arrow-icon fa-regular fa-chevron-down ${openCategories ? 'open' : ''}`}
        onClick={() => handleSetOpenCategories(!openCategories)}
        role="button"
        tabIndex={0}
        title={t('seeAllCategories')}
      ></i>
    </div>
  )
}
